import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CommunityDetail from "../pages/community/page";
import TagPage from "../pages/tag/page";
import CategoryPage from "../pages/category/page";
import RankingPage from "../pages/ranking/page";
import BlogsPage from "../pages/blogs/page";
import BlogDetailPage from "../pages/blog/page";
import SearchPage from "../pages/search/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/community/:id",
    element: <CommunityDetail />,
  },
  {
    path: "/tag/:tag",
    element: <TagPage />,
  },
  {
    path: "/category/:category",
    element: <CategoryPage />,
  },
  {
    path: "/ranking/:type",
    element: <RankingPage />,
  },
  {
    path: "/blogs",
    element: <BlogsPage />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
